import { Component, Input, ViewEncapsulation } from '@angular/core';

enum StatusMode {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PAUSED = 'paused',
  DONE = 'done',
  NEGATIVE = 'negative',
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable',
  STANDARD = 'standard',
  LOCKED = 'locked',
  ONLINE = 'online',
  OFFLINE = 'offline',
  BOOLEAN = 'boolean',
  CUSTOM = 'custom',
  PENDING = 'pending',
  AWAITING_RESPONSE = 'awaiting-response',
}

@Component({
  selector: 'vfs-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StatusComponent {
  @Input() mode: StatusMode = StatusMode.INACTIVE;
  @Input() activeCustom = false;
  @Input() text: string;

  status = StatusMode;
}
